import Vue from "vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import VueCountdown from "@chenfengyuan/vue-countdown";
import loading from "@core/components/loading/index.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import VueQRCodeComponent from "vue-qrcode-component";

Vue.use(VuePersianDatetimePicker, {
  name: "date-picker",
  props: {
    color: "#576fbd",
  },
});
Vue.component("vue-qr-code", VueQRCodeComponent);
Vue.component(FeatherIcon.name, FeatherIcon);
Vue.component(VueCountdown.name, VueCountdown);
Vue.component("loading", loading);
